const Shelf = () => {
  const $document = $(document);
  const $window = $(window);

  const fixImageView = () => {
    $('.track-shelf .card-header noscript').each(function (i, e) {
      const $e = $(e);
      const $box = $e.parent();
      const $img = $($e.text().replace('src', 'data-src').replace('alt=""', 'alt="Imagem"'))
        .addClass('lazyload')
        .attr('src', window.UrlLazyLoadFallback);
      $box.html($img);
    });
    window.lazySizes.loader.checkElems();
  };

  const fixSizeUniteClassContent = () => {
    $('.track-shelf .product_field_85:not(.ready)').each(function (i, e) {
      const $e = $(e);
      const type = $e.find('li').attr('class');
      $e.addClass('ready');
      const $box = $e.closest('.card-body');
      $box.find('.product_field_136').addClass(`based-on-${type}`);
      $box.addClass(`product-based-on-${type}`);
    });

    $('.track-shelf .product_field_136:not(.ready,.based-on-kg,.based-on-por-kg)').each(function (i, e) {
      const $e = $(e);
      const type = $e.find('li').attr('class').trim();
      $e.addClass('ready');
      const $box = $e.closest('.rnk-card-descricao');
      if (!type) {
        $box.addClass('d-none');
      }
    });
  };

  const setupMultiplierForProductsWithMoreThan1Kg = () => {
    const $weightMultiplier = $('.product_field_155');

    $weightMultiplier.each(function (i: number, e: any) {
      const $e = $(e);
      const $multiplierValue = $e.find('ul li');

      if ($multiplierValue.length) {
        const $shelfItem = $e.closest('[data-track-shelf="item"]');
        const currentPrice = +$shelfItem.attr('data-track-shelf-price').replace('R$', '').replace(',', '.').trim();
        const $priceBlock = $shelfItem.find('.rnk-card-price');
        const multipierValue = +$multiplierValue.first().text();
        const finalValue = currentPrice * multipierValue;

        if (finalValue !== 0 && !isNaN(finalValue)) {
          const formattedValue = window.storeTheme.helpers.format.money(finalValue);
          $priceBlock.text(formattedValue);
          $shelfItem.find('div.product_field_85 li.por-kg, div.product_field_85 li.kg').hide();
          $shelfItem.addClass('custom-muliplied');
        }
      }
    });
    $('.weightMultiplier').remove();
    $weightMultiplier.remove();
  };


  const identifyProductSwifteVoce = () => {
    const $productSpecification = $($('script#productSpecification').text());

    try {        
        $('div[data-track-shelf-pid]').each((i, item) => {
            
            let productId = $(item).attr('data-track-shelf-pid');
            $.getJSON(`https://www.swift.com.br/api/catalog_system/pub/products/search?fq=productId:${productId}`, (response) => {
                $(response).each((i, product) => {
                    
                    if (product["Preco Swift"]) {
                        if ($('div[data-track-shelf-pid] .rnk-card-valor .rnk-flag-swift-e-voce').length < 1) {
                            $('div[data-track-shelf-pid] .rnk-card-valor').append('<div class="rnk-flag-swift-e-voce"></div>')
                        }

                        $(item).addClass('rnk-produto-swift-e-voce');

                        $(item).find('.rnk-card-inf').html(`R$${product["Preco Swift"][0]}`);

                        $(item).find('.rnk-flag-swift-e-voce').html(`
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 6C12 5.11641 11.4445 4.36172 10.6617 4.06875C11.0062 3.30938 10.868 2.38359 10.2422 1.75781C9.61641 1.13203 8.69063 0.99375 7.93125 1.33828C7.63828 0.555469 6.88359 0 6 0C5.11641 0 4.36172 0.555469 4.06875 1.33828C3.30938 0.99375 2.38125 1.13203 1.75781 1.75781C1.13203 2.38359 0.99375 3.30938 1.33828 4.06875C0.555469 4.36172 0 5.11641 0 6C0 6.88359 0.555469 7.63828 1.33828 7.93125C0.99375 8.69063 1.13203 9.61875 1.75781 10.2422C2.38125 10.8656 3.30703 11.0086 4.06875 10.6617C4.36172 11.4422 5.11641 12 6 12C6.88359 12 7.63828 11.4445 7.93125 10.6617C8.69531 11.0086 9.61875 10.8656 10.2422 10.2422C10.868 9.61641 11.0062 8.69063 10.6617 7.93125C11.4445 7.63828 12 6.88359 12 6ZM4.5 3.75C4.91414 3.75 5.25 4.08586 5.25 4.5C5.25 4.91414 4.91414 5.25 4.5 5.25C4.08586 5.25 3.75 4.91414 3.75 4.5C3.75 4.08586 4.08586 3.75 4.5 3.75ZM4.78781 8.00742C4.64133 8.15391 4.40391 8.15391 4.25742 8.00742L3.99234 7.74234C3.84586 7.59586 3.84586 7.35844 3.99234 7.21195L7.21195 3.99234C7.35844 3.84586 7.59586 3.84586 7.74234 3.99234L8.00742 4.25742C8.15391 4.40391 8.15391 4.64133 8.00742 4.78781L4.78781 8.00742ZM7.5 8.25C7.08586 8.25 6.75 7.91414 6.75 7.5C6.75 7.08586 7.08586 6.75 7.5 6.75C7.91414 6.75 8.25 7.08586 8.25 7.5C8.25 7.91414 7.91414 8.25 7.5 8.25Z" fill="#73014F"/>
                            </svg>
                            <div>Swift e Você</div>
                        `)
                    }
                })
            })
        });

        if ($('.rnk-body-produto input#___rc-p-id').length > 0) {
          let idProductPdp = $('.rnk-body-produto input#___rc-p-id').val();
          $.getJSON(`https://www.swift.com.br/api/catalog_system/pub/products/search?fq=productId:${idProductPdp}`, (response) => {
              $(response).each((i, specification) => {
                  if (specification['Preco Swift']) {

                      if ($('.rnk-body-produto .product-sku-price .rnk-preco .rnk-flag-swift-mais').length < 1) {
                          $('.rnk-body-produto .product-sku-price .rnk-preco').addClass('rnk-swift-mais')
                          $('.rnk-body-produto .product-sku-price .rnk-preco').append('<div class="rnk-flag-swift-mais"></div>')
                      };

                      $('.rnk-body-produto .product-sku-price .rnk-preco').find('.rnk-flag-swift-mais').html(`
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 6C12 5.11641 11.4445 4.36172 10.6617 4.06875C11.0062 3.30938 10.868 2.38359 10.2422 1.75781C9.61641 1.13203 8.69063 0.99375 7.93125 1.33828C7.63828 0.555469 6.88359 0 6 0C5.11641 0 4.36172 0.555469 4.06875 1.33828C3.30938 0.99375 2.38125 1.13203 1.75781 1.75781C1.13203 2.38359 0.99375 3.30938 1.33828 4.06875C0.555469 4.36172 0 5.11641 0 6C0 6.88359 0.555469 7.63828 1.33828 7.93125C0.99375 8.69063 1.13203 9.61875 1.75781 10.2422C2.38125 10.8656 3.30703 11.0086 4.06875 10.6617C4.36172 11.4422 5.11641 12 6 12C6.88359 12 7.63828 11.4445 7.93125 10.6617C8.69531 11.0086 9.61875 10.8656 10.2422 10.2422C10.868 9.61641 11.0062 8.69063 10.6617 7.93125C11.4445 7.63828 12 6.88359 12 6ZM4.5 3.75C4.91414 3.75 5.25 4.08586 5.25 4.5C5.25 4.91414 4.91414 5.25 4.5 5.25C4.08586 5.25 3.75 4.91414 3.75 4.5C3.75 4.08586 4.08586 3.75 4.5 3.75ZM4.78781 8.00742C4.64133 8.15391 4.40391 8.15391 4.25742 8.00742L3.99234 7.74234C3.84586 7.59586 3.84586 7.35844 3.99234 7.21195L7.21195 3.99234C7.35844 3.84586 7.59586 3.84586 7.74234 3.99234L8.00742 4.25742C8.15391 4.40391 8.15391 4.64133 8.00742 4.78781L4.78781 8.00742ZM7.5 8.25C7.08586 8.25 6.75 7.91414 6.75 7.5C6.75 7.08586 7.08586 6.75 7.5 6.75C7.91414 6.75 8.25 7.08586 8.25 7.5C8.25 7.91414 7.91414 8.25 7.5 8.25Z" fill="#73014F"/>
                          </svg>
                          <div>Swift e Você</div>
                      `)

                      if($productSpecification.find('.value-field.Unidade-de-Medidas').text() == "por Kg") {
                        $('.rnk-swift-mais .texto.d-fex').wrap(`<div class="rnk-swift-mais-preco-de-content"></div>`)
                        $('.rnk-swift-mais .texto.d-fex').after(`<span class="rnk-swift-mais-preco-de">R$${specification['Preco Swift']} </span> `)
                      } else {
                        $('.rnk-swift-mais .texto.d-fex').html(`
                          <span class="rnk-swift-mais-preco-de">R$${specification['Preco Swift']} </span> 
                        `)
                      }
                  }
              })
          })
      }
    } catch (e) {
        console.log(e);
    }
  }

  fixImageView();
  fixSizeUniteClassContent();
  setupMultiplierForProductsWithMoreThan1Kg();
  identifyProductSwifteVoce();

  const remake = () => {
    fixImageView();
    fixSizeUniteClassContent();
    setupMultiplierForProductsWithMoreThan1Kg();
  };

  $window.on('shelf.newItemsLoaded', remake);
  $document.on('ajaxStop', remake);
};

Shelf();

export default {};
